<template>
    <div class="coin-animation" :style="coinsStyle" >
        <div class="coin" ></div>
    </div>
</template>

<script>
import utils from '../../utils/utils.js';
export default {
    props: {
        coinx: Number,
        coiny: Number,
        coinSize: Number,
        coinScale: Number
    },
    data() {
        return {
            cur: 0
        }
    },
    computed: {
        scale() { return this.coinScale || (this.coinSize / 120) || 1 },
        coinsStyle() { return `left: ${this.coinx}px;top: ${this.coiny}px;transform: translate(-50%, -50%) scale(${this.scale});-webkit-transform: translate(-50%, -50%) scale(${this.scale});` }
    }
}
</script>

<style lang="scss" >
@import "../../assets/css/variables.scss";
.coin-animation {
    position: absolute;
    width: 120px;
    height: 120px;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);

    .coin {
        height: 100%;
        background-image: url($assetRoot + "/coins_animation.png");
        animation: coin_animation step-end .3s infinite;
    }

    @-webkit-keyframes coin_animation {
        0% { background-position: 0 0; }
        14% { background-position: -120px 0; }
        28% { background-position: -240px 0; }
        43% { background-position: -360px 0; }
        57% { background-position: -480px 0; }
        72% { background-position: -600px 0; }
        86% { background-position: -720px 0; }
    }

    @keyframes coin_animation {
        0% { background-position: 0 0; }
        14% { background-position: -120px 0; }
        28% { background-position: -240px 0; }
        43% { background-position: -360px 0; }
        57% { background-position: -480px 0; }
        72% { background-position: -600px 0; }
        86% { background-position: -720px 0; }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/animations/RotateCoin.vue